import R from 'ramda';

export function byId(obj, el) {
  obj[el.id] = el;
  return obj;
}

export function withFieldsId(group, fieldLabel = 'fields') {
  const fixedGroup = Object.assign({}, group);
  fixedGroup.fields = R.map(withIds, group[fieldLabel]);
  return fixedGroup;
}

export function withIds(element) {
  return R.reduce(byId, {}, element);
}

export function filterId(id, obj) {
  return obj.id !== id;
}

export function getIndexedContent(content, fromTemplate) {
  const result = {};

  let groups = R.filter(R.propEq('type', 'group'), content);
  let fields = R.filter(R.propEq('type', 'field'), content);
  if (fromTemplate) {
    fields = R.map(R.pick(['id', 'type']), fields);
    groups = R.map(R.pick(['id', 'type']), groups);
    groups = R.map((group) => {
      group.items = [];
      return group;
    }, groups);
  }

  result.fields = R.indexBy(R.prop('id'), fields);
  result.groups = fromTemplate ?
    R.indexBy(R.prop('id'), groups)
    : R.mapObjIndexed((group) => {
      const mappedGroup = R.omit('items', group);
      return Object.assign({}, mappedGroup, {
        items: R.map(item => getIndexedContent(item), group.items || []),
      });
    }, R.indexBy(R.prop('id'), groups));

  return result;
}
